// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export function buildCsvCollection(items: string[] | number[]): string {
  return items.join(",");
}
